// Imports
import { Elements } from '@stripe/react-stripe-js';
import { Stripe, StripeElementsOptionsMode } from '@stripe/stripe-js';
import { forwardRef, useMemo } from 'react';
import { GetPaymentMethodsResponse } from '../../../../../../shareables/types/api/main/website/member/payment-methods/get';
import useStripeAppearance from '../hooks/use-stripe-appearance';
import CardSetupIntentHandler, { CardSetupIntentHandlerRef } from './card-setup-intent-handler';


// Define the accepted props
interface Props {
	currencyCode: GetPaymentMethodsResponse['currencyCode'];
	stripeAccountID: GetPaymentMethodsResponse['stripeAccountID'];
	stripePromise: Promise<Stripe | null>;
	selectedPaymentMethodType: string;
}


// Function component
const StripeElements = forwardRef<CardSetupIntentHandlerRef, Props>(
	({ currencyCode, stripeAccountID, stripePromise, selectedPaymentMethodType }, ref) => {
		// Use Stripe hook
		const appearance = useStripeAppearance();
		
		
		// Create options
		const options = useMemo<StripeElementsOptionsMode>(
			() => ({
				mode: 'setup',
				currency: currencyCode.toLowerCase(),
				setupFutureUsage: 'on_session',
				payment_method_types: ['card'],
				appearance: appearance,
			}),
			[currencyCode, appearance]
		);
		
		
		// Display nothing if missing required information
		if (!currencyCode || !stripeAccountID) {
			return null;
		}
		
		
		// Return JSX
		return (
			<Elements stripe={stripePromise} options={options}>
				<CardSetupIntentHandler ref={ref} selectedPaymentMethodType={selectedPaymentMethodType} />
			</Elements>
		);
	}
);


// @ts-ignore: displayName does exist
StripeElements.displayName = 'StripeElements';

export default StripeElements;
